import module from './index'
import moduleMain from './View'
import modulePanel from './create/View'

let moduleName = 'module->' + module.info.name;

const routes = [
  {
    path: module.info.name,
    name: moduleName,
    component: moduleMain,
    children: [
      {
        path: 'panel',
        name: moduleName + '->panel',
        component: modulePanel
      }
    ]
  }
];

export default routes
